import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '../prime-ng/prime-ng.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FooterComponent } from 'src/app/share-modul/components/layout/footer/footer.component';
import { LoginComponent } from 'src/app/share-modul/components/login/login.component';
import { PageNotFoundComponent } from 'src/app/share-modul/components/page-not-found/page-not-found.component';
import { HeaderComponent } from 'src/app/share-modul/components/layout/header/header.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ChangeLanguageComponent } from 'src/app/share-modul/components/change-language/change-language.component';
import { SignupComponent } from "../../share-modul/components/signup/signup.component";
import { ResetPasswordComponent } from "../../share-modul/components/reset-password/reset-password.component";
import { ForgotPasswordComponent } from "../../share-modul/components/forgot-password/forgot-password.component";
import { ImageCropperModule } from "ngx-image-cropper";
import {
  CropAndCompressImageDialogComponent
} from "../../share-modul/components/crop-and-compress-image-dialog/crop-and-compress-image-dialog.component";
import { DragNDropDirective } from "../../share-modul/directives/drag-n-drop.directive";
import {
  MultipleImagesUploadComponent
} from "../../share-modul/components/multiple-images-upload/multiple-images-upload.component";
import {
  DeleteImagesConfirmComponent
} from "../../share-modul/components/multiple-images-upload/delete-images-confirm/delete-images-confirm.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {
  TermsAndConditionsComponent
} from "../../share-modul/components/terms-and-conditions/terms-and-conditions.component";
import {
  ChangePasswordDialogComponent
} from "../../share-modul/components/change-password-dialog/change-password-dialog.component";
import { LoginWithRefreshTokenComponent } from 'src/app/share-modul/components/login-with-refresh-token/login-with-refresh-token.component';
import { ResetPasswordMobileComponent } from 'src/app/share-modul/components/reset-password-mobile/reset-password-mobile.component';

// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    FooterComponent,
    LoginComponent,
    LoginWithRefreshTokenComponent,
    PageNotFoundComponent,
    HeaderComponent,
    ChangeLanguageComponent,
    SignupComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    CropAndCompressImageDialogComponent,
    MultipleImagesUploadComponent,
    DeleteImagesConfirmComponent,
    DragNDropDirective,
    TermsAndConditionsComponent,
    ChangePasswordDialogComponent,
    ResetPasswordMobileComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    PrimeNgModule,
    CommonModule,
    NgbModule,
    InfiniteScrollModule,
    ImageCropperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader
      }
    }),
  ],
  exports: [
    FooterComponent,
    LoginComponent,
    LoginWithRefreshTokenComponent,
    PageNotFoundComponent,
    HeaderComponent,
    ChangeLanguageComponent,
    ReactiveFormsModule,
    FormsModule,
    PrimeNgModule,
    NgbModule,
    TranslateModule,
    CommonModule,
    ImageCropperModule,
    CropAndCompressImageDialogComponent,
    InfiniteScrollModule
  ]
})
export class SharedModule {}
